import * as React from 'react';
import { cn } from '@/lib/utils';

/**
 * Sober DS (v2) — Empty state. Centered icon chip + title + description with an
 * optional action slot. Neutral surface only (no colored borders), follows the
 * canonical forwardRef + sober-* token pattern.
 */
export interface EmptyProps extends React.HTMLAttributes<HTMLDivElement> {
  icon?: React.ReactNode;
  title: string;
  description?: string;
  action?: React.ReactNode;
}

export const Empty = React.forwardRef<HTMLDivElement, EmptyProps>(
  ({ className, icon, title, description, action, ...props }, ref) => (
    <div
      ref={ref}
      className={cn(
        'flex flex-col items-center gap-3 px-6 py-20 text-center',
        className
      )}
      {...props}
    >
      {icon ? (
        <span className="grid h-[72px] w-[72px] place-items-center rounded-so-xl bg-sober-app text-sober-secondary [&_svg]:size-7">
          {icon}
        </span>
      ) : null}
      <span className="text-so-16 font-bold text-sober-text">{title}</span>
      {description ? (
        <span className="max-w-[360px] text-so-12 text-sober-secondary">
          {description}
        </span>
      ) : null}
      {action ? <div className="mt-1">{action}</div> : null}
    </div>
  )
);
Empty.displayName = 'Empty';
